import { Link } from "react-router-dom";
import type { News } from "@/types/content";

export default function NewsCard({ article }: { article: News }) {
  return (
    <Link
      to={`/detail/news/${article.id}`}
      className="group flex flex-col sm:flex-row gap-4 rounded-lg border border-background-200 bg-background-50 overflow-hidden p-3 md:p-4 cursor-pointer transition-colors hover:border-secondary-300"
    >
      <div className="w-full sm:w-52 shrink-0 aspect-[16/10] sm:aspect-auto sm:h-32 rounded-md overflow-hidden bg-background-200">
        <img
          src={article.thumbnail}
          alt={article.title}
          title={`${article.title} - 继母的诱惑 影视资讯`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 text-xs">
          <span className="rounded-full bg-accent-100 text-accent-800 px-2.5 py-0.5">
            {article.tag}
          </span>
          <span className="text-foreground-500 flex items-center gap-1">
            <i className="ri-time-line" />
            {article.date}
          </span>
        </div>
        <h3 className="mt-2 text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2 hidden sm:block">
          {article.summary}
        </p>
      </div>
    </Link>
  );
}